import ConvenioCrudPage from './ConvenioCrudPage'
export {ConvenioCrudPage}
export default ConvenioCrudPage
